import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    textarea: {
        base: 'text-base text-gray-900 bg-gray-50 border border-gray-300 py-2.5 px-3 rounded-lg focus:border-primary-600 focus:ring-primary-600 outline-hidden',
    },
}).textarea;
